<template>
  <div class="validationIconContainer">
    <div style="display: block">
      <router-link to="/inventoryLinks/validations">Validations</router-link>
      <v-badge
        location="top right"
        :content="structureHeader?.fatalCount"
        :model-value="structureHeader?.fatalCount > 0"
        color="#c10007"
        :offset-x="10"
      >
        <div class="validationIconWrapper" style="color: #c10007">
          <IconTooltip id="icon_validation_Fatal" icon="fa-solid fa-circle-minus" tooltip="Failure" />
        </div>
      </v-badge>
      <v-badge
        location="top right"
        :content="structureHeader?.errorCount"
        :model-value="structureHeader?.errorCount > 0"
        color="rgb(250 247 6)"
        :offset-x="10"
      >
        <div class="validationIconWrapper" style="color: rgb(250 247 6)">
          <IconTooltip id="icon_validation_Error" icon="fa-solid fa-bolt-lightning" tooltip="Error" />
        </div>
      </v-badge>
      <v-badge
        location="top right"
        :content="structureHeader?.warningCount"
        :model-value="structureHeader?.warningCount > 0"
        color="#E65100"
        :offset-x="10"
      >
        <div class="validationIconWrapper" style="color: #e65100">
          <IconTooltip id="icon_validation_Warning" icon="fa-solid fa-triangle-exclamation" tooltip="Warning" />
        </div>
      </v-badge>
      <v-badge
        location="top right"
        :content="structureHeader?.infoCount"
        :model-value="structureHeader?.infoCount > 0"
        color="#1447e6"
        :offset-x="10"
      >
        <div class="validationIconWrapper" style="color: #1447e6">
          <IconTooltip id="icon_validation_Info" icon="fa-solid fa-circle-question" tooltip="Info" />
        </div>
      </v-badge>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useQuickSearchStore } from "@/stores/quickSearch";
import IconTooltip from "@/components/common/IconTooltip.vue";

const quickSearchStore = useQuickSearchStore();
await quickSearchStore.getStructureMetaDataByBRKEY();
const structureHeader = computed(() => quickSearchStore.getStructure());
</script>
<style>
.validationIconContainer {
  padding: 0 5px;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: end;
}

.validationIconWrapper {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
  background-color: #dad4d4;
  border: 1px solid #696868;
  font-size: 22px;
}

.validationIconWrapper > i {
  margin: 0 !important;
}

.validationIconText {
  padding: 0 0 0 6px;
}
</style>
